import { FormattedMessage } from 'react-intl'
import SvgSearch from '../../../icons/SvgSearch'
import React, { useContext } from 'react'
import styles from '../../../styles'
import { fontFamilyBlackerDisplay, fontFamilyMonserrat, gecinaCorailMain, WHITE } from '../../../theme'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import { RechercheContext } from '../utils/RechercheContext'
import { GenreFiltreOffreEnum, getKeyFromGenreFiltreOffreValue } from '../../residence/enums/genreFiltreOffreEnum'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'

const useStyles = makeStyles<{ isLargeScreen: boolean, afficherCarte: boolean, withMinHeight: boolean, fromResidence: boolean }>()(
	(theme, { isLargeScreen, afficherCarte, withMinHeight, fromResidence }) => ({
		...styles(theme),
		iconSearch: {
			marginTop: 30,
			marginBottom: 26
		},
		texteCorail: {
			color: gecinaCorailMain
		},
		aucunResultatTitre: {
			fontSize: 35,
			lineHeight: '40px',
			fontFamily: fontFamilyBlackerDisplay,
			fontWeight: 800,
			color: theme.palette.blue.main
		},
		aucunResultatTexte: {
			fontSize: 20,
			lineHeight: '40px',
			fontFamily: fontFamilyMonserrat,
			fontWeight: 500,
			color: theme.palette.blue.main,
			marginBottom: 40
		},
		aucunResultat: {
			backgroundColor: WHITE,
			borderRadius: 30,
			margin: isLargeScreen ? `30px ${afficherCarte ? 40 : 65}px 0 65px` : '1px 30px 16px',
			fontSize: 16,
			fontFamily: fontFamilyMonserrat,
			color: theme.palette.blue.main,
			fontWeight: 500,
			whiteSpace: 'break-spaces',
			minHeight: withMinHeight ? '65vh' : 'unset'
		},
		nombreOffre: {
			padding: isLargeScreen ? `7px ${afficherCarte ? 40 : 65}px 0 65px` : '1px 30px 16px',
			fontSize: isLargeScreen ? 18 : 16,
			fontFamily: fontFamilyMonserrat,
			color: theme.palette.blue.main,
			fontWeight: 500,
			whiteSpace: 'break-spaces'
		}
	})
)

interface AcceptingProps {
	afficherCarte: boolean,
	fromResidence?: boolean,
	indexFiltre?: number
}

type ResultatsRechercheProps = AcceptingProps

const AucunResultat: React.FC<ResultatsRechercheProps> = (
	{
		afficherCarte,
		fromResidence = false,
		indexFiltre = 0
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { resultat } = useContext(RechercheContext)
	const { classes } = useStyles({ isLargeScreen, afficherCarte, withMinHeight: afficherCarte && resultat.offresApprochantes.length === 0, fromResidence: fromResidence })
	return (
		<>
			{!fromResidence &&
			<Grid
				container
				item
				className={classes.nombreOffre}
				justifyContent="space-between"
				alignItems="center"
			>
				<div>
					<FormattedMessage
						id="recherche.nombreOfrreAucunResultat"
						defaultMessage="<strong>0</strong> logement disponible"
						description="Number of offers message"
						values={{
							strong: (chunk) => <strong>{chunk}</strong>
						}}
					/>
				</div>
			</Grid>
			}
			<Grid container item xs={12} className={classes.aucunResultat}>
				<Grid container item xs={12} justifyContent="center" className={classes.iconSearch}>
					<SvgSearch height={58} width={58} color={gecinaCorailMain} />
				</Grid>
				<Grid container item xs={12} justifyContent="center">
					<Grid container item justifyContent="center" className={classes.aucunResultatTitre}>
						{!fromResidence ?
							<FormattedMessage
								id="recherche.aucunResultatTitre"
								defaultMessage="<span>Aucun résultat</span> ne correspond à votre recherche pour l'instant"
								description="No result message"
								values={{
									span: (chunk) => <span className={classes.texteCorail}>{chunk}</span>
								}}
							/>
							:
							<FormattedMessage
								id={`recherche.aucunResultat.${indexFiltre === GenreFiltreOffreEnum.TOUS ? getKeyFromGenreFiltreOffreValue(indexFiltre) : 'autre'}`}
								defaultMessage="<span>Aucun appartement</span> de cette typologie n'est disponible pour le moment dans cette résidence."
								description="No result message"
								values={{
									span: (chunk) => <span className={classes.texteCorail}>{chunk}</span>
								}}
							/>
						}
					</Grid>
					<Grid container item justifyContent="center" className={classes.aucunResultatTexte}>
						<FormattedMessage
							id={`recherche.aucunResultat${!fromResidence ? '' : 'Residence'}Texte`}
							defaultMessage="Restons connectés, nous vous prévenons dès qu'une offre répond à vos critères."
							description="No result message"
						/>
					</Grid>
				</Grid>
			</Grid>
		</>
	)
}

export default AucunResultat